import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()

export const getBlogCriteria = (abortToken) => {
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.get("/Blogs/Bycriteria", config);
  }
